import { render } from "./FormTemplates.vue?vue&type=template&id=2dc96442"
import script from "./FormTemplates.vue?vue&type=script&lang=js"
export * from "./FormTemplates.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__